import createIcon from '../../createIcon';

/**
 * @component @name AccountTree
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTFWM0gxNVY2SDlWM0gyVjExSDlWOEgxMVYxOEgxNVYyMUgyMlYxM0gxNVYxNkgxM1Y4SDE1VjExSDIyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AccountTree = createIcon('AccountTree', [
  [
    'path',
    { d: 'M22 11V3H15V6H9V3H2V11H9V8H11V18H15V21H22V13H15V16H13V8H15V11H22Z', key: 'e6z4ck' },
  ],
]);

export default AccountTree;
